import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useSearchParams,
} from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import LoginRedirect from "./components/LoginRedirect";
import Dashboard from "./components/Dashboard";
import { AuthProvider } from "./contexts/AuthContext";
import ErrorBoundary from "./ErrorBoundary";
import "./styles/oneCCDP.css";
import DashboardLanding from "./components/DashboardLanding";

function AppContent() {
  const [searchParams] = useSearchParams();

  // Handle SAML callback token (runs inside Router)
  React.useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem("jwt_token", token);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [searchParams]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Helmet>
              <title>OneCCDP Launch</title>
              <meta
                name="description"
                content="Secure single sign-on for OneCCDP districts"
              />
              <meta name="theme-color" content="#004b8d" />
            </Helmet>
            <LoginRedirect />
          </>
        }
      />
      <Route
        path="/refresh"
        element={
          <>
            <Helmet>
              <title>Dashboard - OneCCDP - Refresh</title>
              <meta
                name="description"
                content="OneCCDP Dashboard - Secure access to your district data"
              />
              <meta name="theme-color" content="#00335f" />
            </Helmet>
            <LoginRedirect />
          </>
        }
      />
      <Route
        path="/dashboard"
        element={
          <>
            <Helmet>
              <title>Dashboard - OneCCDP</title>
              <meta
                name="description"
                content="OneCCDP Dashboard - Secure access to your district data"
              />
              <meta name="theme-color" content="#00335f" />
            </Helmet>
            <DashboardLanding />
          </>
        }
      />
      <Route
        path="/dashboard/:id/:workspaceId"
        element={
          <>
            <Helmet>
              <title>Dashboard - Powerbi</title>
              <meta
                name="description"
                content="OneCCDP Dashboard - Secure access to your district data"
              />
              <meta name="theme-color" content="#00335f" />
            </Helmet>
            <Dashboard />
          </>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <Router>
            <AppContent />
          </Router>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
